import { PropsWithChildren } from 'react';
import ThemeCustomization from '@mantis-theme/themes';
import ScrollTop from '@mantis-theme/components/ScrollTop';
import Notistack from '@mantis-theme/components/third-party/Notistack';

export default function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <ThemeCustomization>
      <ScrollTop>
        <Notistack>{children}</Notistack>
      </ScrollTop>
    </ThemeCustomization>
  );
}
